import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import { Box, Text } from '@design-system/pc';
import TrackingService from '@/services/tracking';
import styled from 'styled-components';

interface ConsultButtonProps {
  isShowTopButton: boolean;
}

const ConsultButton = ({ isShowTopButton }: ConsultButtonProps) => {
  const router = useRouter();

  const handleGoQuickConsult = useCallback(() => {
    router.push('/seq-consult?channelType=OP11_02');
  }, [router]);

  return (
    <ConsultButtonWrapper
      width={72}
      height={72}
      borderRadius="50%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      backgroundColor="color_chip.primary"
      onClick={handleGoQuickConsult}
      isShowTopButton={isShowTopButton}
      {...TrackingService.tagGTM('quick_consult_button')}
    >
      <Text variant="headline7" color="color_chip.white" textAlign="center">
        무료
        <br />
        견적 상담
      </Text>
    </ConsultButtonWrapper>
  );
};

const ConsultButtonWrapper = styled(Box)`
  position: absolute;
  right: 0;
  bottom: ${({ isShowTopButton }) => (isShowTopButton ? '62px' : 0)};
  transition: bottom 0.4s ease;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
  cursor: pointer;
`;

export default ConsultButton;
